import src from "IMAGE";
export default { src, width: 2328, height: 662, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AP/ueP7bhvy0p/x3Wf2nZ//Idv/div3sxwD/qWn9bzr5dEr7lCr8xDz8zIb2xn701Ztw3CJV1dSDggAAAABJRU5ErkJggg=="};
